// The player's bookmark names and order for a world (src/game/markbook.ts), read from and saved to the Worker's KV store.
// One query per world; a save puts the stored book straight into the cache.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import { cleanMarkBook, emptyMarkBook, type MarkBook } from "@/game/markbook";

export const markKeys = { book: (wid: number) => ["marks", wid] as const };

export function useMarkBook(wid: number, enabled = true) {
  return useQuery({
    queryKey: markKeys.book(wid),
    queryFn: async () => cleanMarkBook(await api.marks.get(wid)),
    enabled: enabled && wid > 0,
    staleTime: 60_000,
    retry: 1,
    placeholderData: emptyMarkBook,
  });
}

export function useSaveMarks(wid: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (book: MarkBook) => api.marks.save(wid, cleanMarkBook(book)),
    onSuccess: (saved) => qc.setQueryData(markKeys.book(wid), cleanMarkBook(saved)),
  });
}
